// extracted by mini-css-extract-plugin
export default {"About":"About_About__gzO7r","content":"About_content__LU55M"};